<template>
  <div :class="contentWidth === 'boxed' ? 'container p-0' : null">
    <b-navbar
      :toggleable="false"
      :variant="navbarBackgroundColor"
      :type="skin==='semi-dark' ? 'menu-dark' : 'menu-light'"
      class="header-navbar navbar navbar-shadow align-items-center"
    >
      <slot
        name="navbar"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :navbarBackgroundColor="navbarBackgroundColor"
        :navbarTypeClass="[...navbarTypeClass, 'header-navbar navbar navbar-shadow align-items-center']"
      >
        <div class="cus-container">
          <div
            class="navbar-container d-flex content align-items-center"
            style="font-size: 20px"
          >
            <b-navbar-brand
              href="#"
              @click="goto('home')"
            >
              <img 
                src="@/assets/images/logo/favicon.png" 
                alt="Kitten" 
                width="40" 
                height="40"
              >
              <span>{{ $t("WalletConnect.nav."+$route.name) }}</span>
            </b-navbar-brand>
          </div>  
        </div>
      </slot>
    </b-navbar>

    <div class="cus-container view-inside">
      
      <router-view />
    </div>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import SearchBar from '@/@core/layouts/components/app-navbar/components/HomeSearchBar.vue'
import Locale from '@/@core/layouts/components/app-navbar/components/Locale.vue'
import DarkToggler from '@/@core/layouts/components/app-navbar/components/DarkToggler.vue'
import useVerticalLayout from '@/@core/layouts/layout-vertical/useVerticalLayout'
import {isUserLoggedIn} from '@/auth/utils'

export default {
  name: "Index",
  data() {
    return {
      isLoggedIn: false
    }
  },
  created() {
    this.isLoggedIn = isUserLoggedIn();
  },
  setup() {
    const {contentWidth, navbarBackgroundColor, navbarType, footerType, skin} = useAppConfig()
    const {
      toggleVerticalMenuActive,
      navbarTypeClass,
    } = useVerticalLayout(navbarType, footerType);
    return {
      toggleVerticalMenuActive,
      contentWidth, navbarTypeClass,
      // App Config
      navbarBackgroundColor,
      skin,
      isUserLoggedIn
    }
  },
  methods: {
    goto(routeName) {
      this.$router.push({name: routeName})
    },
  }
}
</script>

<style scoped>
.cus-container {
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
}

.navbar-brand {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}

.navbar-brand img {
  margin-right: 26px;
}

.navbar-brand span{
  font-size: 36px;
  font-family: Helvetica;
  color: #6E6B7B;
}

.view-inside {
  padding-top: 60px;
  padding-bottom: 60px;
}
</style>

